<template>
	<c-dialog ref="dialog" title="选择下架渠道" height="70vh">
		<template v-for="(group, i) in channelList">
			<dl v-if="group.length" :key="i" class="list">
				<dt>{{i ? '靓机渠道：' : '暗拍渠道：'}}</dt>
				<dd>
					<ul>
						<li v-for="(item, j) in group" :key="j" :class="{'z-crt': currentChannel.includes(item.channel_id)}" @click="selectHandle(item.channel_id)">{{item.channel_name}}：￥{{item.sale_price}}</li>
					</ul>
				</dd>
			</dl>
		</template>

		<template #button>
			<div class="foot flex-between-center">
				<div class="flex-center">
					<c-checkbox :value="allSelected" readonly @click.native="selectHandle()">全选</c-checkbox>
					<span class="foot-total">已选：{{currentChannel.length}}</span>
				</div>
				<c-button class="foot-button" color="main" size="dialog" @click="submitHandle">确定下架</c-button>
			</div>
		</template>
	</c-dialog>
</template>

<script>
	export default {
		data() {
			return {
				productId: '',
				channelList: [],
				currentChannel: []
			}
		},

		computed: {
			allSelected() {
				return this.channelList.length && !!(this.currentChannel.length == (this.channelList[0].length + this.channelList[1].length));
			}
		},
		
		methods: {
			open(data) {
				this.productId = data.id;
				let channelList = data.channel_list.filter(channel => {
					if (channel.sync_state == 2) return false;
					let onSale = channel.listing_state == 2;
					if (channel.is_dark_auction == 1 && onSale) return false;
					let darkWaitPush = channel.is_dark_auction == 1 && channel.sync_state == 1 && !onSale;
					if (!onSale && !darkWaitPush) return false;
					return true;
				});
				this.channelList = [
					channelList.filter(item => item.is_dark_auction == 1),
					channelList.filter(item => item.is_dark_auction == 2)
				];
				this.currentChannel = [];
				this.$refs.dialog.open();
			},

			selectHandle(id) {
				if (id) {
					if (this.currentChannel.includes(id)) {
						this.currentChannel.splice(this.currentChannel.indexOf(id), 1);
					} else {
						this.currentChannel.push(id);
					}	
				} else {
					if (this.allSelected) {
						this.currentChannel = [];
					} else {
						this.currentChannel = this.channelList[0].concat(this.channelList[1]).map(item => item.channel_id);
					}
				}
			},

			submitHandle() {
				if (!this.currentChannel.length) {
					this.$message({
						message: '请填写要下架的渠道'
					});
					return;
				}

				this.request({
					url: '/sale/product/offShelf',
					data: {
						product_ids: [this.productId],
						channel_id_list: this.currentChannel
					},
					loading: true,
					success: () => {
						this.$message({
							message: '下架成功'
						});
						this.$refs.dialog.close();
						this.$emit('resolve');
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.list {
		padding: 0 .4rem;
		
		dt {
			margin: .5rem .02rem .3rem;
			font-size: .3rem;
			color: #666;
		}

		dd {
			li {
				position: relative;
				border: .02rem solid #F5F5F5;
				border-radius: .08rem;
				padding: 0 .22rem;
				overflow: hidden;
				line-height: .72rem;
				font-size: .3rem;
				color: #444;
				background: #F5F5F5;

				&:nth-child(n+2) {
					margin-top: .18rem;
				}

				&.z-crt {
					border-color: var(--color-main);
					color: var(--color-main);
					background: #fff;

					&:after {
						content: '\e66f';
						position: absolute;
						right: .02rem;
						bottom: .02rem;
						line-height: 1;
						font-family: 'iconfont';
						font-size: .14rem;
						color: #fff;
					}

					&:before {
						content: '';
						position: absolute;
						right: 0;
						bottom: 0;
						border-bottom: .32rem solid var(--color-main);
						border-left: .42rem solid rgba(255,255,255,0);
					}
				}
			}
		}
	}

	.foot {
		width: 100%;

		&-total {
			margin-left: .24rem;
			font-size: .26rem;
			color: #666;
		}

		&-button {
			max-width: 2.74rem;
		}
	}
</style>